import WorkflowService from 'src/modules/workflow/workflowService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'WORKFLOW_VIEW';

const workflowViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowViewActions.FIND_STARTED,
      });

      const record = await WorkflowService.find(id);

      dispatch({
        type: workflowViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: workflowViewActions.FIND_ERROR,
      });

      getHistory().push('/workflow');
    }
  },
};

export default workflowViewActions;
